module.exports = __webpack_public_path__ + "img/02.87ac5cc3.jpg";